// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.1
// source: webview/channel/native_messages.proto

/* eslint-disable */

export const protobufPackage = 'channel.webview';

export enum SnackNotificationLevel {
  INFO = 0,
  WARN = 1,
  ERROR = 2,
  SUCCESS = 3,
  UNRECOGNIZED = -1,
}

export function snackNotificationLevelFromJSON(
  object: any
): SnackNotificationLevel {
  switch (object) {
    case 0:
    case 'INFO':
      return SnackNotificationLevel.INFO;
    case 1:
    case 'WARN':
      return SnackNotificationLevel.WARN;
    case 2:
    case 'ERROR':
      return SnackNotificationLevel.ERROR;
    case 3:
    case 'SUCCESS':
      return SnackNotificationLevel.SUCCESS;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SnackNotificationLevel.UNRECOGNIZED;
  }
}

export function snackNotificationLevelToJSON(
  object: SnackNotificationLevel
): string {
  switch (object) {
    case SnackNotificationLevel.INFO:
      return 'INFO';
    case SnackNotificationLevel.WARN:
      return 'WARN';
    case SnackNotificationLevel.ERROR:
      return 'ERROR';
    case SnackNotificationLevel.SUCCESS:
      return 'SUCCESS';
    case SnackNotificationLevel.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export enum Collection {
  COLLECTION_UNKNOWN = 0,
  BASEBALL = 1,
  FOOTBALL = 2,
  FOOTBALL_NATIONAL_SERIES = 3,
  NBA = 4,
  UNRECOGNIZED = -1,
}

export function collectionFromJSON(object: any): Collection {
  switch (object) {
    case 0:
    case 'COLLECTION_UNKNOWN':
      return Collection.COLLECTION_UNKNOWN;
    case 1:
    case 'BASEBALL':
      return Collection.BASEBALL;
    case 2:
    case 'FOOTBALL':
      return Collection.FOOTBALL;
    case 3:
    case 'FOOTBALL_NATIONAL_SERIES':
      return Collection.FOOTBALL_NATIONAL_SERIES;
    case 4:
    case 'NBA':
      return Collection.NBA;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return Collection.UNRECOGNIZED;
  }
}

export function collectionToJSON(object: Collection): string {
  switch (object) {
    case Collection.COLLECTION_UNKNOWN:
      return 'COLLECTION_UNKNOWN';
    case Collection.BASEBALL:
      return 'BASEBALL';
    case Collection.FOOTBALL:
      return 'FOOTBALL';
    case Collection.FOOTBALL_NATIONAL_SERIES:
      return 'FOOTBALL_NATIONAL_SERIES';
    case Collection.NBA:
      return 'NBA';
    case Collection.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export enum Rarity {
  RARITY_UNKNOWN = 0,
  COMMON = 1,
  CUSTOM_SERIES = 2,
  LIMITED = 3,
  RARE = 4,
  SUPER_RARE = 5,
  UNIQUE = 6,
  UNRECOGNIZED = -1,
}

export function rarityFromJSON(object: any): Rarity {
  switch (object) {
    case 0:
    case 'RARITY_UNKNOWN':
      return Rarity.RARITY_UNKNOWN;
    case 1:
    case 'COMMON':
      return Rarity.COMMON;
    case 2:
    case 'CUSTOM_SERIES':
      return Rarity.CUSTOM_SERIES;
    case 3:
    case 'LIMITED':
      return Rarity.LIMITED;
    case 4:
    case 'RARE':
      return Rarity.RARE;
    case 5:
    case 'SUPER_RARE':
      return Rarity.SUPER_RARE;
    case 6:
    case 'UNIQUE':
      return Rarity.UNIQUE;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return Rarity.UNRECOGNIZED;
  }
}

export function rarityToJSON(object: Rarity): string {
  switch (object) {
    case Rarity.RARITY_UNKNOWN:
      return 'RARITY_UNKNOWN';
    case Rarity.COMMON:
      return 'COMMON';
    case Rarity.CUSTOM_SERIES:
      return 'CUSTOM_SERIES';
    case Rarity.LIMITED:
      return 'LIMITED';
    case Rarity.RARE:
      return 'RARE';
    case Rarity.SUPER_RARE:
      return 'SUPER_RARE';
    case Rarity.UNIQUE:
      return 'UNIQUE';
    case Rarity.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

/** Payload for channel postMessage: WebView -> native app */
export interface ChannelMessage {
  logout?: Logout | undefined;
  socialShare?: SocialShare | undefined;
  managerShare?: ManagerShare | undefined;
  debugScreen?: DebugScreen | undefined;
  clickButton?: ClickButton | undefined;
  displaySnackNotification?: DisplaySnackNotification | undefined;
  loaded?: Loaded | undefined;
  instantBuy?: InstantBuy | undefined;
  rewardClaimed?: RewardClaimed | undefined;
  /** @deprecated */
  managerProgressionTaskClaimed?: ManagerProgressionTaskClaimed | undefined;
  animateScore?: AnimateScore | undefined;
  userEngagementScoreIncrement?: UserEngagementScoreIncrement | undefined;
  enablePushNotifications?: EnablePushNotifications | undefined;
  signUpWithOauth?: SignUpWithOAuth | undefined;
  setBottomTabsVisibility?: SetBottomTabsVisibility | undefined;
  showPrivacyPreferences?: ShowPrivacyPreferences | undefined;
  clickSearch?: ClickSearch | undefined;
  trackInAppEvent?: TrackInAppEvent | undefined;
  loginWithEphemeralToken?: LoginWithEphemeralToken | undefined;
  loginWithJwtToken?: LoginWithJWTToken | undefined;
  showCardScreen?: ShowCardScreen | undefined;
  footballOnboardingEvent?: FootballOnboardingEvent | undefined;
  openBrowser?: OpenBrowser | undefined;
  nbaOnboardingEventComplete?: NBAOnboardingEventComplete | undefined;
  mlbOnboardingEventComplete?: MLBOnboardingEventComplete | undefined;
  buyInGameCurrencyPack?: BuyInGameCurrencyPack | undefined;
  buyCardPack?: BuyCardPack | undefined;
  claimFreeCardPack?: ClaimFreeCardPack | undefined;
  taskClaimed?: TaskClaimed | undefined;
  openPaymentBox?: OpenPaymentBox | undefined;
  toggleNavigationBar?: ToggleNavigationBar | undefined;
  openCart?: OpenCart | undefined;
  closeCurrentWebview?: CloseCurrentWebview | undefined;
  updateUserLifecycle?: UpdateUserLifecycle | undefined;
  updateLanguagePreference?: UpdateLanguagePreference | undefined;
  openMissions?: OpenMissions | undefined;
  openBlog?: OpenBlog | undefined;
  refreshGemsBalance?: RefreshGemsBalance | undefined;
}

/**
 * Command to logout of app.
 * Triggered by logout button in webview.
 */
export interface Logout {
  isExplicit: boolean;
}

/**
 * Command to all social share.
 * Triggered by share button on card detail, lineup, my club pages.
 */
export interface SocialShare {
  title: string | undefined;
  description: string | undefined;
  url: string | undefined;
  image: SharingImage | undefined;
  message: string | undefined;
  trackingEventName: string | undefined;
  trackingEventContext: string | undefined;
  sharedItemId: string | undefined;
  sharedItem: string | undefined;
}

/**
 * Command to share manager profile.
 * Triggered by share button on manager profile page.
 */
export interface ManagerShare {
  profile: SocialShare | undefined;
  gallery: SocialShare | undefined;
  highlightedDeck: SocialShare | undefined;
}

/**
 * Command to open native Debug screen.
 * Triggered by Debug Screen button in the webview menu.
 */
export interface DebugScreen {}

/**
 * Command to start the in-app-purchase flow for a card.
 * Triggered by tapping an InstantBuy card in the marketplace.
 */
export interface InstantBuy {
  cardSlug: string | undefined;
  playerSlug: string | undefined;
  rarity: Rarity;
  collection: Collection;
}

export interface OpenPaymentBox {}

export interface SharingImage {
  post: string | undefined;
  story: string | undefined;
  square: string | undefined;
}

export interface ClickButton {}

export interface AnimateScore {
  score: number;
  previousScore: number;
}

export interface Loaded {
  page?: PageResource | undefined;
  iframe?: IFrameResource | undefined;
  app?: AppResource | undefined;
}

export interface UserEngagementScoreIncrement {
  score: number;
  source: UserEngagementScoreIncrement_Source;
}

export enum UserEngagementScoreIncrement_Source {
  UNKNOWN = 0,
  PURCHASE_CARD = 1,
  MAKE_DEPOSIT = 2,
  SUBMIT_LINEUP = 3,
  CLAIM_REWARD = 4,
  CLAIM_REFERRABLE_REWARD = 5,
  CRAFT_CARD = 6,
  SEAL_CARD = 7,
  CLICK_MY_CIRCLE_BUTTON = 8,
  START_FOLLOWING_USER = 9,
  PICK_PLAYER_IN_DAILY_MISSION = 10,
  LEVEL_UP_CARDS = 11,
  CLICK_SCORES_TAB = 12,
  UNRECOGNIZED = -1,
}

export function userEngagementScoreIncrement_SourceFromJSON(
  object: any
): UserEngagementScoreIncrement_Source {
  switch (object) {
    case 0:
    case 'UNKNOWN':
      return UserEngagementScoreIncrement_Source.UNKNOWN;
    case 1:
    case 'PURCHASE_CARD':
      return UserEngagementScoreIncrement_Source.PURCHASE_CARD;
    case 2:
    case 'MAKE_DEPOSIT':
      return UserEngagementScoreIncrement_Source.MAKE_DEPOSIT;
    case 3:
    case 'SUBMIT_LINEUP':
      return UserEngagementScoreIncrement_Source.SUBMIT_LINEUP;
    case 4:
    case 'CLAIM_REWARD':
      return UserEngagementScoreIncrement_Source.CLAIM_REWARD;
    case 5:
    case 'CLAIM_REFERRABLE_REWARD':
      return UserEngagementScoreIncrement_Source.CLAIM_REFERRABLE_REWARD;
    case 6:
    case 'CRAFT_CARD':
      return UserEngagementScoreIncrement_Source.CRAFT_CARD;
    case 7:
    case 'SEAL_CARD':
      return UserEngagementScoreIncrement_Source.SEAL_CARD;
    case 8:
    case 'CLICK_MY_CIRCLE_BUTTON':
      return UserEngagementScoreIncrement_Source.CLICK_MY_CIRCLE_BUTTON;
    case 9:
    case 'START_FOLLOWING_USER':
      return UserEngagementScoreIncrement_Source.START_FOLLOWING_USER;
    case 10:
    case 'PICK_PLAYER_IN_DAILY_MISSION':
      return UserEngagementScoreIncrement_Source.PICK_PLAYER_IN_DAILY_MISSION;
    case 11:
    case 'LEVEL_UP_CARDS':
      return UserEngagementScoreIncrement_Source.LEVEL_UP_CARDS;
    case 12:
    case 'CLICK_SCORES_TAB':
      return UserEngagementScoreIncrement_Source.CLICK_SCORES_TAB;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return UserEngagementScoreIncrement_Source.UNRECOGNIZED;
  }
}

export function userEngagementScoreIncrement_SourceToJSON(
  object: UserEngagementScoreIncrement_Source
): string {
  switch (object) {
    case UserEngagementScoreIncrement_Source.UNKNOWN:
      return 'UNKNOWN';
    case UserEngagementScoreIncrement_Source.PURCHASE_CARD:
      return 'PURCHASE_CARD';
    case UserEngagementScoreIncrement_Source.MAKE_DEPOSIT:
      return 'MAKE_DEPOSIT';
    case UserEngagementScoreIncrement_Source.SUBMIT_LINEUP:
      return 'SUBMIT_LINEUP';
    case UserEngagementScoreIncrement_Source.CLAIM_REWARD:
      return 'CLAIM_REWARD';
    case UserEngagementScoreIncrement_Source.CLAIM_REFERRABLE_REWARD:
      return 'CLAIM_REFERRABLE_REWARD';
    case UserEngagementScoreIncrement_Source.CRAFT_CARD:
      return 'CRAFT_CARD';
    case UserEngagementScoreIncrement_Source.SEAL_CARD:
      return 'SEAL_CARD';
    case UserEngagementScoreIncrement_Source.CLICK_MY_CIRCLE_BUTTON:
      return 'CLICK_MY_CIRCLE_BUTTON';
    case UserEngagementScoreIncrement_Source.START_FOLLOWING_USER:
      return 'START_FOLLOWING_USER';
    case UserEngagementScoreIncrement_Source.PICK_PLAYER_IN_DAILY_MISSION:
      return 'PICK_PLAYER_IN_DAILY_MISSION';
    case UserEngagementScoreIncrement_Source.LEVEL_UP_CARDS:
      return 'LEVEL_UP_CARDS';
    case UserEngagementScoreIncrement_Source.CLICK_SCORES_TAB:
      return 'CLICK_SCORES_TAB';
    case UserEngagementScoreIncrement_Source.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface PageResource {
  url: string;
}

export interface IFrameResource {
  url: string;
}

export interface ShowPrivacyPreferences {}

export interface AppResource {
  progress: number;
}

export interface DisplaySnackNotification {
  message: string | undefined;
  level: SnackNotificationLevel;
  url: string | undefined;
}

export interface RewardClaimed {}

export interface ManagerProgressionTaskClaimed {}

export interface EnablePushNotifications {}

export interface SignUpWithOAuth {
  platform: string | undefined;
  acceptAgeLimit: boolean;
  acceptGameRules: boolean;
  acceptPrivacyPolicy: boolean;
  acceptTerms: boolean;
  agreedToReceiveOffersFromPartners: boolean;
  agreedToReceiveOffersFromPartnersSpecific: string[];
  nickname: string | undefined;
  sport: SignUpWithOAuth_Sport;
  impactClickId: string | undefined;
  googleClickId: string | undefined;
  facebookClickId: string | undefined;
  twitterClickId: string | undefined;
  tikTokClickId: string | undefined;
  redditClickId: string | undefined;
  snapchatClickId: string | undefined;
}

export enum SignUpWithOAuth_Sport {
  FOOTBALL = 0,
  BASEBALL = 1,
  NBA = 2,
  UNRECOGNIZED = -1,
}

export function signUpWithOAuth_SportFromJSON(
  object: any
): SignUpWithOAuth_Sport {
  switch (object) {
    case 0:
    case 'FOOTBALL':
      return SignUpWithOAuth_Sport.FOOTBALL;
    case 1:
    case 'BASEBALL':
      return SignUpWithOAuth_Sport.BASEBALL;
    case 2:
    case 'NBA':
      return SignUpWithOAuth_Sport.NBA;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SignUpWithOAuth_Sport.UNRECOGNIZED;
  }
}

export function signUpWithOAuth_SportToJSON(
  object: SignUpWithOAuth_Sport
): string {
  switch (object) {
    case SignUpWithOAuth_Sport.FOOTBALL:
      return 'FOOTBALL';
    case SignUpWithOAuth_Sport.BASEBALL:
      return 'BASEBALL';
    case SignUpWithOAuth_Sport.NBA:
      return 'NBA';
    case SignUpWithOAuth_Sport.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface SetBottomTabsVisibility {
  isVisible: boolean;
}

export interface ClickSearch {}

export interface TrackInAppEvent {
  event: string | undefined;
  jsonProperties: string | undefined;
}

export interface LoginWithEphemeralToken {
  token: string | undefined;
}

export interface LoginWithJWTToken {
  token: string | undefined;
  userId: string | undefined;
  email: string | undefined;
  expiredAt: number;
  sport: LoginWithJWTToken_Sport;
}

export enum LoginWithJWTToken_Sport {
  FOOTBALL = 0,
  BASEBALL = 1,
  NBA = 2,
  UNRECOGNIZED = -1,
}

export function loginWithJWTToken_SportFromJSON(
  object: any
): LoginWithJWTToken_Sport {
  switch (object) {
    case 0:
    case 'FOOTBALL':
      return LoginWithJWTToken_Sport.FOOTBALL;
    case 1:
    case 'BASEBALL':
      return LoginWithJWTToken_Sport.BASEBALL;
    case 2:
    case 'NBA':
      return LoginWithJWTToken_Sport.NBA;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return LoginWithJWTToken_Sport.UNRECOGNIZED;
  }
}

export function loginWithJWTToken_SportToJSON(
  object: LoginWithJWTToken_Sport
): string {
  switch (object) {
    case LoginWithJWTToken_Sport.FOOTBALL:
      return 'FOOTBALL';
    case LoginWithJWTToken_Sport.BASEBALL:
      return 'BASEBALL';
    case LoginWithJWTToken_Sport.NBA:
      return 'NBA';
    case LoginWithJWTToken_Sport.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

/**
 * Command to show the in-app card screen
 * Triggered by tapping a card in the marketplace grid.
 */
export interface ShowCardScreen {
  cardSlug: string | undefined;
  collection: Collection;
}

/**
 * Command to share user action on the onboard flow.
 * Triggered by tapping a button in the football onboarding flow.
 */
export interface FootballOnboardingEvent {
  skipOnboarding?: FootballSkipOnboarding | undefined;
  onboardingComplete?: FootballOnboardingComplete | undefined;
}

/** Trigger by finishing the NBA onboarding flow */
export interface NBAOnboardingEventComplete {}

/** Trigger by finishing the MLB onboarding flow */
export interface MLBOnboardingEventComplete {}

export interface FootballSkipOnboarding {}

export interface FootballOnboardingComplete {}

export interface OpenBrowser {
  url: string | undefined;
}

/**
 * Command to start the in-app-purchase flow for an InGameCurrencyPack.
 * Triggered by tapping an InGameCurrencyPack in the marketplace.
 */
export interface BuyInGameCurrencyPack {
  packId: string | undefined;
}

/**
 * Command to start the purchase of a card pack.
 * Triggered by tapping an Card pack in the marketplace.
 */
export interface BuyCardPack {
  packId: string | undefined;
}

/**
 * Command to claim the free card pack.
 * Triggered by tapping an the free card pack in the marketplace.
 */
export interface ClaimFreeCardPack {
  taskId: string | undefined;
}

/**
 * Command to notify the platform about claimed task to trigger update(s)
 * Triggered after a given task is claimed
 */
export interface TaskClaimed {
  taskId: string;
}

export interface ToggleNavigationBar {
  isVisible: boolean;
}

export interface OpenCart {}

export interface CloseCurrentWebview {}

export interface UpdateUserLifecycle {
  updatedKey: string;
}

export interface UpdateLanguagePreference {
  locale: string;
}

export interface OpenMissions {
  category: string | undefined;
  rarity: string | undefined;
}

export interface OpenBlog {
  url: string | undefined;
}

export interface RefreshGemsBalance {}

export const ChannelMessage: MessageFns<ChannelMessage> = {
  fromJSON(object: any): ChannelMessage {
    return {
      logout: isSet(object.logout) ? Logout.fromJSON(object.logout) : undefined,
      socialShare: isSet(object.social_share)
        ? SocialShare.fromJSON(object.social_share)
        : undefined,
      managerShare: isSet(object.manager_share)
        ? ManagerShare.fromJSON(object.manager_share)
        : undefined,
      debugScreen: isSet(object.debug_screen)
        ? DebugScreen.fromJSON(object.debug_screen)
        : undefined,
      clickButton: isSet(object.click_button)
        ? ClickButton.fromJSON(object.click_button)
        : undefined,
      displaySnackNotification: isSet(object.display_snack_notification)
        ? DisplaySnackNotification.fromJSON(object.display_snack_notification)
        : undefined,
      loaded: isSet(object.loaded) ? Loaded.fromJSON(object.loaded) : undefined,
      instantBuy: isSet(object.instant_buy)
        ? InstantBuy.fromJSON(object.instant_buy)
        : undefined,
      rewardClaimed: isSet(object.reward_claimed)
        ? RewardClaimed.fromJSON(object.reward_claimed)
        : undefined,
      managerProgressionTaskClaimed: isSet(
        object.manager_progression_task_claimed
      )
        ? ManagerProgressionTaskClaimed.fromJSON(
            object.manager_progression_task_claimed
          )
        : undefined,
      animateScore: isSet(object.animate_score)
        ? AnimateScore.fromJSON(object.animate_score)
        : undefined,
      userEngagementScoreIncrement: isSet(
        object.user_engagement_score_increment
      )
        ? UserEngagementScoreIncrement.fromJSON(
            object.user_engagement_score_increment
          )
        : undefined,
      enablePushNotifications: isSet(object.enable_push_notifications)
        ? EnablePushNotifications.fromJSON(object.enable_push_notifications)
        : undefined,
      signUpWithOauth: isSet(object.sign_up_with_oauth)
        ? SignUpWithOAuth.fromJSON(object.sign_up_with_oauth)
        : undefined,
      setBottomTabsVisibility: isSet(object.set_bottom_tabs_visibility)
        ? SetBottomTabsVisibility.fromJSON(object.set_bottom_tabs_visibility)
        : undefined,
      showPrivacyPreferences: isSet(object.show_privacy_preferences)
        ? ShowPrivacyPreferences.fromJSON(object.show_privacy_preferences)
        : undefined,
      clickSearch: isSet(object.click_search)
        ? ClickSearch.fromJSON(object.click_search)
        : undefined,
      trackInAppEvent: isSet(object.track_in_app_event)
        ? TrackInAppEvent.fromJSON(object.track_in_app_event)
        : undefined,
      loginWithEphemeralToken: isSet(object.login_with_ephemeral_token)
        ? LoginWithEphemeralToken.fromJSON(object.login_with_ephemeral_token)
        : undefined,
      loginWithJwtToken: isSet(object.login_with_jwt_token)
        ? LoginWithJWTToken.fromJSON(object.login_with_jwt_token)
        : undefined,
      showCardScreen: isSet(object.show_card_screen)
        ? ShowCardScreen.fromJSON(object.show_card_screen)
        : undefined,
      footballOnboardingEvent: isSet(object.football_onboarding_event)
        ? FootballOnboardingEvent.fromJSON(object.football_onboarding_event)
        : undefined,
      openBrowser: isSet(object.open_browser)
        ? OpenBrowser.fromJSON(object.open_browser)
        : undefined,
      nbaOnboardingEventComplete: isSet(object.nba_onboarding_event_complete)
        ? NBAOnboardingEventComplete.fromJSON(
            object.nba_onboarding_event_complete
          )
        : undefined,
      mlbOnboardingEventComplete: isSet(object.mlb_onboarding_event_complete)
        ? MLBOnboardingEventComplete.fromJSON(
            object.mlb_onboarding_event_complete
          )
        : undefined,
      buyInGameCurrencyPack: isSet(object.buy_in_game_currency_pack)
        ? BuyInGameCurrencyPack.fromJSON(object.buy_in_game_currency_pack)
        : undefined,
      buyCardPack: isSet(object.buy_card_pack)
        ? BuyCardPack.fromJSON(object.buy_card_pack)
        : undefined,
      claimFreeCardPack: isSet(object.claim_free_card_pack)
        ? ClaimFreeCardPack.fromJSON(object.claim_free_card_pack)
        : undefined,
      taskClaimed: isSet(object.task_claimed)
        ? TaskClaimed.fromJSON(object.task_claimed)
        : undefined,
      openPaymentBox: isSet(object.open_payment_box)
        ? OpenPaymentBox.fromJSON(object.open_payment_box)
        : undefined,
      toggleNavigationBar: isSet(object.toggle_navigation_bar)
        ? ToggleNavigationBar.fromJSON(object.toggle_navigation_bar)
        : undefined,
      openCart: isSet(object.open_cart)
        ? OpenCart.fromJSON(object.open_cart)
        : undefined,
      closeCurrentWebview: isSet(object.close_current_webview)
        ? CloseCurrentWebview.fromJSON(object.close_current_webview)
        : undefined,
      updateUserLifecycle: isSet(object.update_user_lifecycle)
        ? UpdateUserLifecycle.fromJSON(object.update_user_lifecycle)
        : undefined,
      updateLanguagePreference: isSet(object.update_language_preference)
        ? UpdateLanguagePreference.fromJSON(object.update_language_preference)
        : undefined,
      openMissions: isSet(object.open_missions)
        ? OpenMissions.fromJSON(object.open_missions)
        : undefined,
      openBlog: isSet(object.open_blog)
        ? OpenBlog.fromJSON(object.open_blog)
        : undefined,
      refreshGemsBalance: isSet(object.refresh_gems_balance)
        ? RefreshGemsBalance.fromJSON(object.refresh_gems_balance)
        : undefined,
    };
  },

  toJSON(message: ChannelMessage): unknown {
    const obj: any = {};
    if (message.logout !== undefined) {
      obj.logout = Logout.toJSON(message.logout);
    }
    if (message.socialShare !== undefined) {
      obj.social_share = SocialShare.toJSON(message.socialShare);
    }
    if (message.managerShare !== undefined) {
      obj.manager_share = ManagerShare.toJSON(message.managerShare);
    }
    if (message.debugScreen !== undefined) {
      obj.debug_screen = DebugScreen.toJSON(message.debugScreen);
    }
    if (message.clickButton !== undefined) {
      obj.click_button = ClickButton.toJSON(message.clickButton);
    }
    if (message.displaySnackNotification !== undefined) {
      obj.display_snack_notification = DisplaySnackNotification.toJSON(
        message.displaySnackNotification
      );
    }
    if (message.loaded !== undefined) {
      obj.loaded = Loaded.toJSON(message.loaded);
    }
    if (message.instantBuy !== undefined) {
      obj.instant_buy = InstantBuy.toJSON(message.instantBuy);
    }
    if (message.rewardClaimed !== undefined) {
      obj.reward_claimed = RewardClaimed.toJSON(message.rewardClaimed);
    }
    if (message.managerProgressionTaskClaimed !== undefined) {
      obj.manager_progression_task_claimed =
        ManagerProgressionTaskClaimed.toJSON(
          message.managerProgressionTaskClaimed
        );
    }
    if (message.animateScore !== undefined) {
      obj.animate_score = AnimateScore.toJSON(message.animateScore);
    }
    if (message.userEngagementScoreIncrement !== undefined) {
      obj.user_engagement_score_increment = UserEngagementScoreIncrement.toJSON(
        message.userEngagementScoreIncrement
      );
    }
    if (message.enablePushNotifications !== undefined) {
      obj.enable_push_notifications = EnablePushNotifications.toJSON(
        message.enablePushNotifications
      );
    }
    if (message.signUpWithOauth !== undefined) {
      obj.sign_up_with_oauth = SignUpWithOAuth.toJSON(message.signUpWithOauth);
    }
    if (message.setBottomTabsVisibility !== undefined) {
      obj.set_bottom_tabs_visibility = SetBottomTabsVisibility.toJSON(
        message.setBottomTabsVisibility
      );
    }
    if (message.showPrivacyPreferences !== undefined) {
      obj.show_privacy_preferences = ShowPrivacyPreferences.toJSON(
        message.showPrivacyPreferences
      );
    }
    if (message.clickSearch !== undefined) {
      obj.click_search = ClickSearch.toJSON(message.clickSearch);
    }
    if (message.trackInAppEvent !== undefined) {
      obj.track_in_app_event = TrackInAppEvent.toJSON(message.trackInAppEvent);
    }
    if (message.loginWithEphemeralToken !== undefined) {
      obj.login_with_ephemeral_token = LoginWithEphemeralToken.toJSON(
        message.loginWithEphemeralToken
      );
    }
    if (message.loginWithJwtToken !== undefined) {
      obj.login_with_jwt_token = LoginWithJWTToken.toJSON(
        message.loginWithJwtToken
      );
    }
    if (message.showCardScreen !== undefined) {
      obj.show_card_screen = ShowCardScreen.toJSON(message.showCardScreen);
    }
    if (message.footballOnboardingEvent !== undefined) {
      obj.football_onboarding_event = FootballOnboardingEvent.toJSON(
        message.footballOnboardingEvent
      );
    }
    if (message.openBrowser !== undefined) {
      obj.open_browser = OpenBrowser.toJSON(message.openBrowser);
    }
    if (message.nbaOnboardingEventComplete !== undefined) {
      obj.nba_onboarding_event_complete = NBAOnboardingEventComplete.toJSON(
        message.nbaOnboardingEventComplete
      );
    }
    if (message.mlbOnboardingEventComplete !== undefined) {
      obj.mlb_onboarding_event_complete = MLBOnboardingEventComplete.toJSON(
        message.mlbOnboardingEventComplete
      );
    }
    if (message.buyInGameCurrencyPack !== undefined) {
      obj.buy_in_game_currency_pack = BuyInGameCurrencyPack.toJSON(
        message.buyInGameCurrencyPack
      );
    }
    if (message.buyCardPack !== undefined) {
      obj.buy_card_pack = BuyCardPack.toJSON(message.buyCardPack);
    }
    if (message.claimFreeCardPack !== undefined) {
      obj.claim_free_card_pack = ClaimFreeCardPack.toJSON(
        message.claimFreeCardPack
      );
    }
    if (message.taskClaimed !== undefined) {
      obj.task_claimed = TaskClaimed.toJSON(message.taskClaimed);
    }
    if (message.openPaymentBox !== undefined) {
      obj.open_payment_box = OpenPaymentBox.toJSON(message.openPaymentBox);
    }
    if (message.toggleNavigationBar !== undefined) {
      obj.toggle_navigation_bar = ToggleNavigationBar.toJSON(
        message.toggleNavigationBar
      );
    }
    if (message.openCart !== undefined) {
      obj.open_cart = OpenCart.toJSON(message.openCart);
    }
    if (message.closeCurrentWebview !== undefined) {
      obj.close_current_webview = CloseCurrentWebview.toJSON(
        message.closeCurrentWebview
      );
    }
    if (message.updateUserLifecycle !== undefined) {
      obj.update_user_lifecycle = UpdateUserLifecycle.toJSON(
        message.updateUserLifecycle
      );
    }
    if (message.updateLanguagePreference !== undefined) {
      obj.update_language_preference = UpdateLanguagePreference.toJSON(
        message.updateLanguagePreference
      );
    }
    if (message.openMissions !== undefined) {
      obj.open_missions = OpenMissions.toJSON(message.openMissions);
    }
    if (message.openBlog !== undefined) {
      obj.open_blog = OpenBlog.toJSON(message.openBlog);
    }
    if (message.refreshGemsBalance !== undefined) {
      obj.refresh_gems_balance = RefreshGemsBalance.toJSON(
        message.refreshGemsBalance
      );
    }
    return obj;
  },
};

export const Logout: MessageFns<Logout> = {
  fromJSON(object: any): Logout {
    return {
      isExplicit: isSet(object.is_explicit)
        ? globalThis.Boolean(object.is_explicit)
        : false,
    };
  },

  toJSON(message: Logout): unknown {
    const obj: any = {};
    if (message.isExplicit !== undefined) {
      obj.is_explicit = message.isExplicit;
    }
    return obj;
  },
};

export const SocialShare: MessageFns<SocialShare> = {
  fromJSON(object: any): SocialShare {
    return {
      title: isSet(object.title) ? String(object.title) : undefined,
      description: isSet(object.description)
        ? String(object.description)
        : undefined,
      url: isSet(object.url) ? String(object.url) : undefined,
      image: isSet(object.image)
        ? SharingImage.fromJSON(object.image)
        : undefined,
      message: isSet(object.message) ? String(object.message) : undefined,
      trackingEventName: isSet(object.tracking_event_name)
        ? String(object.tracking_event_name)
        : undefined,
      trackingEventContext: isSet(object.tracking_event_context)
        ? String(object.tracking_event_context)
        : undefined,
      sharedItemId: isSet(object.shared_item_id)
        ? String(object.shared_item_id)
        : undefined,
      sharedItem: isSet(object.shared_item)
        ? String(object.shared_item)
        : undefined,
    };
  },

  toJSON(message: SocialShare): unknown {
    const obj: any = {};
    if (message.title !== undefined) {
      obj.title = message.title;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    if (message.image !== undefined) {
      obj.image = SharingImage.toJSON(message.image);
    }
    if (message.message !== undefined) {
      obj.message = message.message;
    }
    if (message.trackingEventName !== undefined) {
      obj.tracking_event_name = message.trackingEventName;
    }
    if (message.trackingEventContext !== undefined) {
      obj.tracking_event_context = message.trackingEventContext;
    }
    if (message.sharedItemId !== undefined) {
      obj.shared_item_id = message.sharedItemId;
    }
    if (message.sharedItem !== undefined) {
      obj.shared_item = message.sharedItem;
    }
    return obj;
  },
};

export const ManagerShare: MessageFns<ManagerShare> = {
  fromJSON(object: any): ManagerShare {
    return {
      profile: isSet(object.profile)
        ? SocialShare.fromJSON(object.profile)
        : undefined,
      gallery: isSet(object.gallery)
        ? SocialShare.fromJSON(object.gallery)
        : undefined,
      highlightedDeck: isSet(object.highlighted_deck)
        ? SocialShare.fromJSON(object.highlighted_deck)
        : undefined,
    };
  },

  toJSON(message: ManagerShare): unknown {
    const obj: any = {};
    if (message.profile !== undefined) {
      obj.profile = SocialShare.toJSON(message.profile);
    }
    if (message.gallery !== undefined) {
      obj.gallery = SocialShare.toJSON(message.gallery);
    }
    if (message.highlightedDeck !== undefined) {
      obj.highlighted_deck = SocialShare.toJSON(message.highlightedDeck);
    }
    return obj;
  },
};

export const DebugScreen: MessageFns<DebugScreen> = {
  fromJSON(_: any): DebugScreen {
    return {};
  },

  toJSON(_: DebugScreen): unknown {
    const obj: any = {};
    return obj;
  },
};

export const InstantBuy: MessageFns<InstantBuy> = {
  fromJSON(object: any): InstantBuy {
    return {
      cardSlug: isSet(object.card_slug) ? String(object.card_slug) : undefined,
      playerSlug: isSet(object.player_slug)
        ? String(object.player_slug)
        : undefined,
      rarity: isSet(object.rarity) ? rarityFromJSON(object.rarity) : 0,
      collection: isSet(object.collection)
        ? collectionFromJSON(object.collection)
        : 0,
    };
  },

  toJSON(message: InstantBuy): unknown {
    const obj: any = {};
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.playerSlug !== undefined) {
      obj.player_slug = message.playerSlug;
    }
    if (message.rarity !== undefined) {
      obj.rarity = rarityToJSON(message.rarity);
    }
    if (message.collection !== undefined) {
      obj.collection = collectionToJSON(message.collection);
    }
    return obj;
  },
};

export const OpenPaymentBox: MessageFns<OpenPaymentBox> = {
  fromJSON(_: any): OpenPaymentBox {
    return {};
  },

  toJSON(_: OpenPaymentBox): unknown {
    const obj: any = {};
    return obj;
  },
};

export const SharingImage: MessageFns<SharingImage> = {
  fromJSON(object: any): SharingImage {
    return {
      post: isSet(object.post) ? String(object.post) : undefined,
      story: isSet(object.story) ? String(object.story) : undefined,
      square: isSet(object.square) ? String(object.square) : undefined,
    };
  },

  toJSON(message: SharingImage): unknown {
    const obj: any = {};
    if (message.post !== undefined) {
      obj.post = message.post;
    }
    if (message.story !== undefined) {
      obj.story = message.story;
    }
    if (message.square !== undefined) {
      obj.square = message.square;
    }
    return obj;
  },
};

export const ClickButton: MessageFns<ClickButton> = {
  fromJSON(_: any): ClickButton {
    return {};
  },

  toJSON(_: ClickButton): unknown {
    const obj: any = {};
    return obj;
  },
};

export const AnimateScore: MessageFns<AnimateScore> = {
  fromJSON(object: any): AnimateScore {
    return {
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
      previousScore: isSet(object.previous_score)
        ? globalThis.Number(object.previous_score)
        : 0,
    };
  },

  toJSON(message: AnimateScore): unknown {
    const obj: any = {};
    if (message.score !== undefined) {
      obj.score = message.score;
    }
    if (message.previousScore !== undefined) {
      obj.previous_score = message.previousScore;
    }
    return obj;
  },
};

export const Loaded: MessageFns<Loaded> = {
  fromJSON(object: any): Loaded {
    return {
      page: isSet(object.page) ? PageResource.fromJSON(object.page) : undefined,
      iframe: isSet(object.iframe)
        ? IFrameResource.fromJSON(object.iframe)
        : undefined,
      app: isSet(object.app) ? AppResource.fromJSON(object.app) : undefined,
    };
  },

  toJSON(message: Loaded): unknown {
    const obj: any = {};
    if (message.page !== undefined) {
      obj.page = PageResource.toJSON(message.page);
    }
    if (message.iframe !== undefined) {
      obj.iframe = IFrameResource.toJSON(message.iframe);
    }
    if (message.app !== undefined) {
      obj.app = AppResource.toJSON(message.app);
    }
    return obj;
  },
};

export const UserEngagementScoreIncrement: MessageFns<UserEngagementScoreIncrement> =
  {
    fromJSON(object: any): UserEngagementScoreIncrement {
      return {
        score: isSet(object.score) ? globalThis.Number(object.score) : 0,
        source: isSet(object.source)
          ? userEngagementScoreIncrement_SourceFromJSON(object.source)
          : 0,
      };
    },

    toJSON(message: UserEngagementScoreIncrement): unknown {
      const obj: any = {};
      if (message.score !== undefined) {
        obj.score = Math.round(message.score);
      }
      if (message.source !== undefined) {
        obj.source = userEngagementScoreIncrement_SourceToJSON(message.source);
      }
      return obj;
    },
  };

export const PageResource: MessageFns<PageResource> = {
  fromJSON(object: any): PageResource {
    return { url: isSet(object.url) ? globalThis.String(object.url) : '' };
  },

  toJSON(message: PageResource): unknown {
    const obj: any = {};
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    return obj;
  },
};

export const IFrameResource: MessageFns<IFrameResource> = {
  fromJSON(object: any): IFrameResource {
    return { url: isSet(object.url) ? globalThis.String(object.url) : '' };
  },

  toJSON(message: IFrameResource): unknown {
    const obj: any = {};
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    return obj;
  },
};

export const ShowPrivacyPreferences: MessageFns<ShowPrivacyPreferences> = {
  fromJSON(_: any): ShowPrivacyPreferences {
    return {};
  },

  toJSON(_: ShowPrivacyPreferences): unknown {
    const obj: any = {};
    return obj;
  },
};

export const AppResource: MessageFns<AppResource> = {
  fromJSON(object: any): AppResource {
    return {
      progress: isSet(object.progress) ? globalThis.Number(object.progress) : 0,
    };
  },

  toJSON(message: AppResource): unknown {
    const obj: any = {};
    if (message.progress !== undefined) {
      obj.progress = message.progress;
    }
    return obj;
  },
};

export const DisplaySnackNotification: MessageFns<DisplaySnackNotification> = {
  fromJSON(object: any): DisplaySnackNotification {
    return {
      message: isSet(object.message) ? String(object.message) : undefined,
      level: isSet(object.level)
        ? snackNotificationLevelFromJSON(object.level)
        : 0,
      url: isSet(object.url) ? String(object.url) : undefined,
    };
  },

  toJSON(message: DisplaySnackNotification): unknown {
    const obj: any = {};
    if (message.message !== undefined) {
      obj.message = message.message;
    }
    if (message.level !== undefined) {
      obj.level = snackNotificationLevelToJSON(message.level);
    }
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    return obj;
  },
};

export const RewardClaimed: MessageFns<RewardClaimed> = {
  fromJSON(_: any): RewardClaimed {
    return {};
  },

  toJSON(_: RewardClaimed): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ManagerProgressionTaskClaimed: MessageFns<ManagerProgressionTaskClaimed> =
  {
    fromJSON(_: any): ManagerProgressionTaskClaimed {
      return {};
    },

    toJSON(_: ManagerProgressionTaskClaimed): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const EnablePushNotifications: MessageFns<EnablePushNotifications> = {
  fromJSON(_: any): EnablePushNotifications {
    return {};
  },

  toJSON(_: EnablePushNotifications): unknown {
    const obj: any = {};
    return obj;
  },
};

export const SignUpWithOAuth: MessageFns<SignUpWithOAuth> = {
  fromJSON(object: any): SignUpWithOAuth {
    return {
      platform: isSet(object.platform) ? String(object.platform) : undefined,
      acceptAgeLimit: isSet(object.accept_age_limit)
        ? globalThis.Boolean(object.accept_age_limit)
        : false,
      acceptGameRules: isSet(object.accept_game_rules)
        ? globalThis.Boolean(object.accept_game_rules)
        : false,
      acceptPrivacyPolicy: isSet(object.accept_privacy_policy)
        ? globalThis.Boolean(object.accept_privacy_policy)
        : false,
      acceptTerms: isSet(object.accept_terms)
        ? globalThis.Boolean(object.accept_terms)
        : false,
      agreedToReceiveOffersFromPartners: isSet(
        object.agreed_to_receive_offers_from_partners
      )
        ? globalThis.Boolean(object.agreed_to_receive_offers_from_partners)
        : false,
      agreedToReceiveOffersFromPartnersSpecific: globalThis.Array.isArray(
        object?.agreed_to_receive_offers_from_partners_specific
      )
        ? object.agreed_to_receive_offers_from_partners_specific.map((e: any) =>
            String(e)
          )
        : [],
      nickname: isSet(object.nickname) ? String(object.nickname) : undefined,
      sport: isSet(object.sport)
        ? signUpWithOAuth_SportFromJSON(object.sport)
        : 0,
      impactClickId: isSet(object.impact_click_id)
        ? String(object.impact_click_id)
        : undefined,
      googleClickId: isSet(object.google_click_id)
        ? String(object.google_click_id)
        : undefined,
      facebookClickId: isSet(object.facebook_click_id)
        ? String(object.facebook_click_id)
        : undefined,
      twitterClickId: isSet(object.twitter_click_id)
        ? String(object.twitter_click_id)
        : undefined,
      tikTokClickId: isSet(object.tik_tok_click_id)
        ? String(object.tik_tok_click_id)
        : undefined,
      redditClickId: isSet(object.reddit_click_id)
        ? String(object.reddit_click_id)
        : undefined,
      snapchatClickId: isSet(object.snapchat_click_id)
        ? String(object.snapchat_click_id)
        : undefined,
    };
  },

  toJSON(message: SignUpWithOAuth): unknown {
    const obj: any = {};
    if (message.platform !== undefined) {
      obj.platform = message.platform;
    }
    if (message.acceptAgeLimit !== undefined) {
      obj.accept_age_limit = message.acceptAgeLimit;
    }
    if (message.acceptGameRules !== undefined) {
      obj.accept_game_rules = message.acceptGameRules;
    }
    if (message.acceptPrivacyPolicy !== undefined) {
      obj.accept_privacy_policy = message.acceptPrivacyPolicy;
    }
    if (message.acceptTerms !== undefined) {
      obj.accept_terms = message.acceptTerms;
    }
    if (message.agreedToReceiveOffersFromPartners !== undefined) {
      obj.agreed_to_receive_offers_from_partners =
        message.agreedToReceiveOffersFromPartners;
    }
    if (message.agreedToReceiveOffersFromPartnersSpecific?.length) {
      obj.agreed_to_receive_offers_from_partners_specific =
        message.agreedToReceiveOffersFromPartnersSpecific;
    }
    if (message.nickname !== undefined) {
      obj.nickname = message.nickname;
    }
    if (message.sport !== undefined) {
      obj.sport = signUpWithOAuth_SportToJSON(message.sport);
    }
    if (message.impactClickId !== undefined) {
      obj.impact_click_id = message.impactClickId;
    }
    if (message.googleClickId !== undefined) {
      obj.google_click_id = message.googleClickId;
    }
    if (message.facebookClickId !== undefined) {
      obj.facebook_click_id = message.facebookClickId;
    }
    if (message.twitterClickId !== undefined) {
      obj.twitter_click_id = message.twitterClickId;
    }
    if (message.tikTokClickId !== undefined) {
      obj.tik_tok_click_id = message.tikTokClickId;
    }
    if (message.redditClickId !== undefined) {
      obj.reddit_click_id = message.redditClickId;
    }
    if (message.snapchatClickId !== undefined) {
      obj.snapchat_click_id = message.snapchatClickId;
    }
    return obj;
  },
};

export const SetBottomTabsVisibility: MessageFns<SetBottomTabsVisibility> = {
  fromJSON(object: any): SetBottomTabsVisibility {
    return {
      isVisible: isSet(object.is_visible)
        ? globalThis.Boolean(object.is_visible)
        : false,
    };
  },

  toJSON(message: SetBottomTabsVisibility): unknown {
    const obj: any = {};
    if (message.isVisible !== undefined) {
      obj.is_visible = message.isVisible;
    }
    return obj;
  },
};

export const ClickSearch: MessageFns<ClickSearch> = {
  fromJSON(_: any): ClickSearch {
    return {};
  },

  toJSON(_: ClickSearch): unknown {
    const obj: any = {};
    return obj;
  },
};

export const TrackInAppEvent: MessageFns<TrackInAppEvent> = {
  fromJSON(object: any): TrackInAppEvent {
    return {
      event: isSet(object.event) ? String(object.event) : undefined,
      jsonProperties: isSet(object.json_properties)
        ? String(object.json_properties)
        : undefined,
    };
  },

  toJSON(message: TrackInAppEvent): unknown {
    const obj: any = {};
    if (message.event !== undefined) {
      obj.event = message.event;
    }
    if (message.jsonProperties !== undefined) {
      obj.json_properties = message.jsonProperties;
    }
    return obj;
  },
};

export const LoginWithEphemeralToken: MessageFns<LoginWithEphemeralToken> = {
  fromJSON(object: any): LoginWithEphemeralToken {
    return { token: isSet(object.token) ? String(object.token) : undefined };
  },

  toJSON(message: LoginWithEphemeralToken): unknown {
    const obj: any = {};
    if (message.token !== undefined) {
      obj.token = message.token;
    }
    return obj;
  },
};

export const LoginWithJWTToken: MessageFns<LoginWithJWTToken> = {
  fromJSON(object: any): LoginWithJWTToken {
    return {
      token: isSet(object.token) ? String(object.token) : undefined,
      userId: isSet(object.user_id) ? String(object.user_id) : undefined,
      email: isSet(object.email) ? String(object.email) : undefined,
      expiredAt: isSet(object.expired_at)
        ? globalThis.Number(object.expired_at)
        : 0,
      sport: isSet(object.sport)
        ? loginWithJWTToken_SportFromJSON(object.sport)
        : 0,
    };
  },

  toJSON(message: LoginWithJWTToken): unknown {
    const obj: any = {};
    if (message.token !== undefined) {
      obj.token = message.token;
    }
    if (message.userId !== undefined) {
      obj.user_id = message.userId;
    }
    if (message.email !== undefined) {
      obj.email = message.email;
    }
    if (message.expiredAt !== undefined) {
      obj.expired_at = Math.round(message.expiredAt);
    }
    if (message.sport !== undefined) {
      obj.sport = loginWithJWTToken_SportToJSON(message.sport);
    }
    return obj;
  },
};

export const ShowCardScreen: MessageFns<ShowCardScreen> = {
  fromJSON(object: any): ShowCardScreen {
    return {
      cardSlug: isSet(object.card_slug) ? String(object.card_slug) : undefined,
      collection: isSet(object.collection)
        ? collectionFromJSON(object.collection)
        : 0,
    };
  },

  toJSON(message: ShowCardScreen): unknown {
    const obj: any = {};
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.collection !== undefined) {
      obj.collection = collectionToJSON(message.collection);
    }
    return obj;
  },
};

export const FootballOnboardingEvent: MessageFns<FootballOnboardingEvent> = {
  fromJSON(object: any): FootballOnboardingEvent {
    return {
      skipOnboarding: isSet(object.skip_onboarding)
        ? FootballSkipOnboarding.fromJSON(object.skip_onboarding)
        : undefined,
      onboardingComplete: isSet(object.onboarding_complete)
        ? FootballOnboardingComplete.fromJSON(object.onboarding_complete)
        : undefined,
    };
  },

  toJSON(message: FootballOnboardingEvent): unknown {
    const obj: any = {};
    if (message.skipOnboarding !== undefined) {
      obj.skip_onboarding = FootballSkipOnboarding.toJSON(
        message.skipOnboarding
      );
    }
    if (message.onboardingComplete !== undefined) {
      obj.onboarding_complete = FootballOnboardingComplete.toJSON(
        message.onboardingComplete
      );
    }
    return obj;
  },
};

export const NBAOnboardingEventComplete: MessageFns<NBAOnboardingEventComplete> =
  {
    fromJSON(_: any): NBAOnboardingEventComplete {
      return {};
    },

    toJSON(_: NBAOnboardingEventComplete): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const MLBOnboardingEventComplete: MessageFns<MLBOnboardingEventComplete> =
  {
    fromJSON(_: any): MLBOnboardingEventComplete {
      return {};
    },

    toJSON(_: MLBOnboardingEventComplete): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const FootballSkipOnboarding: MessageFns<FootballSkipOnboarding> = {
  fromJSON(_: any): FootballSkipOnboarding {
    return {};
  },

  toJSON(_: FootballSkipOnboarding): unknown {
    const obj: any = {};
    return obj;
  },
};

export const FootballOnboardingComplete: MessageFns<FootballOnboardingComplete> =
  {
    fromJSON(_: any): FootballOnboardingComplete {
      return {};
    },

    toJSON(_: FootballOnboardingComplete): unknown {
      const obj: any = {};
      return obj;
    },
  };

export const OpenBrowser: MessageFns<OpenBrowser> = {
  fromJSON(object: any): OpenBrowser {
    return { url: isSet(object.url) ? String(object.url) : undefined };
  },

  toJSON(message: OpenBrowser): unknown {
    const obj: any = {};
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    return obj;
  },
};

export const BuyInGameCurrencyPack: MessageFns<BuyInGameCurrencyPack> = {
  fromJSON(object: any): BuyInGameCurrencyPack {
    return {
      packId: isSet(object.pack_id) ? String(object.pack_id) : undefined,
    };
  },

  toJSON(message: BuyInGameCurrencyPack): unknown {
    const obj: any = {};
    if (message.packId !== undefined) {
      obj.pack_id = message.packId;
    }
    return obj;
  },
};

export const BuyCardPack: MessageFns<BuyCardPack> = {
  fromJSON(object: any): BuyCardPack {
    return {
      packId: isSet(object.pack_id) ? String(object.pack_id) : undefined,
    };
  },

  toJSON(message: BuyCardPack): unknown {
    const obj: any = {};
    if (message.packId !== undefined) {
      obj.pack_id = message.packId;
    }
    return obj;
  },
};

export const ClaimFreeCardPack: MessageFns<ClaimFreeCardPack> = {
  fromJSON(object: any): ClaimFreeCardPack {
    return {
      taskId: isSet(object.task_id) ? String(object.task_id) : undefined,
    };
  },

  toJSON(message: ClaimFreeCardPack): unknown {
    const obj: any = {};
    if (message.taskId !== undefined) {
      obj.task_id = message.taskId;
    }
    return obj;
  },
};

export const TaskClaimed: MessageFns<TaskClaimed> = {
  fromJSON(object: any): TaskClaimed {
    return {
      taskId: isSet(object.task_id) ? globalThis.String(object.task_id) : '',
    };
  },

  toJSON(message: TaskClaimed): unknown {
    const obj: any = {};
    if (message.taskId !== undefined) {
      obj.task_id = message.taskId;
    }
    return obj;
  },
};

export const ToggleNavigationBar: MessageFns<ToggleNavigationBar> = {
  fromJSON(object: any): ToggleNavigationBar {
    return {
      isVisible: isSet(object.is_visible)
        ? globalThis.Boolean(object.is_visible)
        : false,
    };
  },

  toJSON(message: ToggleNavigationBar): unknown {
    const obj: any = {};
    if (message.isVisible !== undefined) {
      obj.is_visible = message.isVisible;
    }
    return obj;
  },
};

export const OpenCart: MessageFns<OpenCart> = {
  fromJSON(_: any): OpenCart {
    return {};
  },

  toJSON(_: OpenCart): unknown {
    const obj: any = {};
    return obj;
  },
};

export const CloseCurrentWebview: MessageFns<CloseCurrentWebview> = {
  fromJSON(_: any): CloseCurrentWebview {
    return {};
  },

  toJSON(_: CloseCurrentWebview): unknown {
    const obj: any = {};
    return obj;
  },
};

export const UpdateUserLifecycle: MessageFns<UpdateUserLifecycle> = {
  fromJSON(object: any): UpdateUserLifecycle {
    return {
      updatedKey: isSet(object.updated_key)
        ? globalThis.String(object.updated_key)
        : '',
    };
  },

  toJSON(message: UpdateUserLifecycle): unknown {
    const obj: any = {};
    if (message.updatedKey !== undefined) {
      obj.updated_key = message.updatedKey;
    }
    return obj;
  },
};

export const UpdateLanguagePreference: MessageFns<UpdateLanguagePreference> = {
  fromJSON(object: any): UpdateLanguagePreference {
    return {
      locale: isSet(object.locale) ? globalThis.String(object.locale) : '',
    };
  },

  toJSON(message: UpdateLanguagePreference): unknown {
    const obj: any = {};
    if (message.locale !== undefined) {
      obj.locale = message.locale;
    }
    return obj;
  },
};

export const OpenMissions: MessageFns<OpenMissions> = {
  fromJSON(object: any): OpenMissions {
    return {
      category: isSet(object.category) ? String(object.category) : undefined,
      rarity: isSet(object.rarity) ? String(object.rarity) : undefined,
    };
  },

  toJSON(message: OpenMissions): unknown {
    const obj: any = {};
    if (message.category !== undefined) {
      obj.category = message.category;
    }
    if (message.rarity !== undefined) {
      obj.rarity = message.rarity;
    }
    return obj;
  },
};

export const OpenBlog: MessageFns<OpenBlog> = {
  fromJSON(object: any): OpenBlog {
    return { url: isSet(object.url) ? String(object.url) : undefined };
  },

  toJSON(message: OpenBlog): unknown {
    const obj: any = {};
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    return obj;
  },
};

export const RefreshGemsBalance: MessageFns<RefreshGemsBalance> = {
  fromJSON(_: any): RefreshGemsBalance {
    return {};
  },

  toJSON(_: RefreshGemsBalance): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
